import { navigate } from "@reach/router";
import { format } from "date-fns";
import { getUTCOffset } from "helpers/dates";
import React from "react";
import { useDispatch } from "react-redux";
import { closeRightPanel } from "reducers/rightPanel";
import { cancelCalendarMeeting, getUpdatedMeetings } from "../MeetingsApi";
import { MeetingsCustomButton } from "./MeetingsCustomButton";
import { setEventsList, useToast } from "@avamae/calendar-module";
import { translations } from "translations";

export type CandidatesData = {
  name: string;
  assessmentProngId: number | null;
}[];

type MeetingsTileProps = {
  assessmentType: string;
  jobTitle: string;
  variant: "SMALL" | "LARGE";
  eventsId: number;
  startDate: Date;
  assessmentProngIdList: string[];
  candidatesData?: CandidatesData;
  hasBookedCandidates?: boolean;
};

const MeetingsTile: React.FC<MeetingsTileProps> = ({
  assessmentType,
  jobTitle,
  eventsId,
  variant,
  startDate,
  assessmentProngIdList,
  candidatesData,
  hasBookedCandidates = true,
}) => {
  const dispatch = useDispatch();

  const handleCancelSuccess = useToast(
    "Your cancellation request has been sent.",
    "#124a57",
    3000,
    useDispatch
  );
  const handleCancelError = useToast(
    "Cancellation request failed, please try again.",
    "#dc4444",
    3000,
    useDispatch
  );

  const cancelMeeting = () => {
    (async () => {
      const TimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const result = await cancelCalendarMeeting({
        EventID: eventsId,
        TimeZone,
      });
      if (result.response) {
        handleCancelSuccess();
        const meetingsResult = await getUpdatedMeetings();
        if (meetingsResult.response) {
          const meetings = meetingsResult.response;
          dispatch(setEventsList(meetings));
          dispatch(closeRightPanel());
        }
      } else {
        handleCancelError();
      }
    })();
  };

  const startVideo = () => {
    navigate("/review-video", {
      state: {
        eventsId,
        assessmentProngIdList,
        assessmentName: assessmentType,
        candidatesData,
      },
    });
    dispatch(closeRightPanel());
  };

  const formattedDate = `${format(
    startDate,
    "dd/MM/yyyy | h:mm aa"
  )} ${getUTCOffset()}`;

  const canJoinMeeting = () => {
    return new Date() >= startDate && hasBookedCandidates;
  };

  return (
    <>
      <div className="MeetingsTileWrapper">
        <div
          className={`MeetingsTileInner ${
            variant === "LARGE" ? "MeetingsTileInner--large" : ""
          }`}
        >
          <div className="MeetingsTile__details">
            <div className="MeetingsTile__jobTitle">{jobTitle}</div>
            <div className="MeetingsTile__assessmentType">{assessmentType}</div>
            {variant === "LARGE" ? (
              <div className="MeetingsTile__dateTime">{formattedDate}</div>
            ) : (
              ""
            )}
            {!hasBookedCandidates && (
              <div className="MeetingsTile__assessmentType">
                {translations.errors.No_Booked_Candidates}
              </div>
            )}
          </div>
          <div
            className={`MeetingsTile__buttonWrapper ${
              variant === "LARGE" ? "MeetingsTile__buttonWrapper--large" : ""
            }`}
          >
            <MeetingsCustomButton
              onClick={startVideo}
              type="JOIN"
              variant={variant}
              className={`${canJoinMeeting() ? "" : "Disabled"}`}
            />
            <MeetingsCustomButton
              onClick={cancelMeeting}
              type="CANCEL"
              variant={variant}
            />
          </div>
        </div>
        <div className="MeetingsTileButtons"></div>
      </div>
    </>
  );
};

export default MeetingsTile;
